import { Literature, Reviewer } from '../types';
import api from './api.ts';

export interface ReviewSubmission {
    literature_id: number;
    reviewer_id: number;
    decision: string;
    reason: string;
}

export const reviewService = {
    async submitReview(data: ReviewSubmission) {
        const response = await api.post('/reviewer/decision', data);
        return response.data;
    },

    async getReviewer(): Promise<Reviewer[]> {
        const response = await api.get('/reviewer/list');
        return response.data;
    },

    getDoiUrl(doi: string) {
        return `https://doi.org/${doi}`;
    },

    async uploadPdf(literatureId: number, formData: FormData): Promise<{ message: string; item: Literature }> {
        const response = await api.post(`/literature/upload-pdf?literature_id=${literatureId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    async importReviews(reviews: any[]): Promise<any> {
        try {
            const response = await api.post('/reviewer/import', { reviews });
            return response.data;
        } catch (error) {
            console.error('Error importing reviews:', error);
            throw error;
        }
    },
    async dryRunImportReviews(reviews: any[]): Promise<any> {
        try {
            const response = await api.post('/reviewer/dry-run', { reviews });
            return response.data;
        } catch (error) {
            console.error('Error in dry run import:', error);
            throw error;
        }
    },

    async confirmImportReviews(reviews: any[]): Promise<any> {
        try {
            const response = await api.post('/reviewer/confirm-import', { reviews });
            return response.data;
        } catch (error) {
            console.error('Error confirming import:', error);
            throw error;
        }
    },
};
